<template>
    <span class="DateEditorRequest">
        {{ OldValueFormatted }}
        <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode && CheckPermission(EditPermission)" v-on:click="ShowEditModal()" class="pointer" />
        <b-modal ref="component-modal" v-bind:title="ModalTitle" @shown="HandleShown()" hide-footer>
            <b-container>
                <b-form @submit="Save">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Old Value:</label>
                                <input class="form-control" v-model="OldValueFormatted" disabled />
                                <label>New Value:</label>
                                <flat-pickr v-model="NewValue" class="form-control" ref="showfocus" v-bind:required="Required" :config="Config"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="WarningNotice != null">
                        <h3>WARNING</h3>
                        <p>{{ WarningNotice }}</p>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>

                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </span>

</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "OldValue",
            "PropertyName",
            "RecordId",
            "EditMode",
            "DataLabel",
            "UpdateMethod",
            "Required",
            "WarningNotice",
            "NullString",
            "GlobalUpdate",
            "DispatchOnSuccess",
            "ChartId",
            "EditPermission"
        ],
        data: function () {
            return {
                NewValue: "",
                //Config: {
                //    dateFormat: 'm/d/Y',
                //    allowInput: true,
                //    required: true
                //},
                Config: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: false
                }
                
            };
        },
        methods: {
            ShowEditModal() {
                this.NewValue = this.OldValueFormattedDate;
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            Save(e) {
                e.preventDefault();
                //if (this.Required == true && this.NewValue == "") {
                //    console.log("empty date detected");
                //    vm.$refs.showfocus.focus();
                //    return;
                //}
                this.$MasterAPI.ExecuteRequest("POST", this.UpdateMethod, { Id: this.RecordId, [this.PropertyName]: this.NewValue }, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                let vm = this;
                vm.OldValue = vm.NewValueFormattedDate;
                vm.$refs['component-modal'].hide();
                //Perform Global Updates
                if (vm.GlobalUpdate) {
                    vm.$GlobalUpdate.ExecuteGlobalUpdate(vm.ChartId);
                }
                //Fire Events if present
                if (vm.DispatchOnSuccess != null) {
                    vm.DispatchOnSuccess.forEach(function (item) {
                        EventBus.$emit(item);
                    });
                }
                vm.$emit("success");
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null || value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            HandleShown() {
                //this.$refs.showfocus.$el.focus();
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            flatPickr
        },
        computed: {
            ModalTitle: function () {
                return "Editing " + this.DataLabel;
            },
            OldValueFormatted: function () {
                if (this.OldValue != null && this.OldValue != '') {
                    return this.formatDate(this.OldValue, "MM/DD/YYYY");
                } else {
                    return this.NullString;
                }
                
            },
            OldValueFormattedDate: function () {
                if (this.OldValue != null && this.OldValue != '') {
                    return this.formatDate(this.OldValue, "MM/DD/YYYY");
                } else {
                    return null;
                }
                
            },
            NewValueFormatted: function () {
                if (this.NewValue != null && this.NewValue != '') {
                    return this.formatDate(this.NewValue, "MM/DD/YYYY");
                } else {
                    return this.NullString;
                }
            },
            NewValueFormattedDate: function () {
                if (this.NewValue != null && this.NewValue != '') {
                    return this.formatDate(this.NewValue, "MM/DD/YYYY");
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>
</style>